import React, { useState, useRef } from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet, mobile } from "../../../styles/breakpoints";

import TES1 from "../../../img/png/home/testimonials/tes1.png";
import TES2 from "../../../img/png/home/testimonials/tes2.png";
import TES3 from "../../../img/png/home/testimonials/tes3.png";
import TES4 from "../../../img/png/home/testimonials/tes4.png";
import TES5 from "../../../img/png/home/testimonials/tes5.png";
import PhoneImg from "../../../img/png/home/testimonials/phone.png";
import { useIsMobile } from "../../../components/helpers/ScreenCheck";
import { useMotionValueEvent, useScroll } from "framer-motion";
import { useI18n } from "../../../i18n";

const testimonials = [
  {
    img: TES1,
    title: "Skylar, 19",
    quoteKey: "testimonial_quote_1",
    description: `“Zilouet surprised me with pieces I wouldn’t normally choose, but
          they totally work with my wardrobe and look great on me. It’s like
          having a style-savvy friend who knows exactly what I need.”`,
  },
  {
    img: TES2,
    title: "Jamie, 22",
    quoteKey: "testimonial_quote_2",
    description: `“Zilouet is seriously a lifesaver! When I order stuff online, I
          never have to return anything because it all fits perfectly. The app
          knows my body so well that even clothes from different stores are
          the right size. It’s like having a personal stylist who totally gets
          my style.”`,
  },
  {
    img: TES3,
    title: "Avery, 20",
    quoteKey: "testimonial_quote_3",
    description: `“The virtual try-on feature lets me see exactly how outfits will
          look on me, which makes shopping so much easier. It’s like the app
          knows my body better than I do. My style game has seriously leveled
          up.”`,
  },
  {
    img: TES4,
    title: "Jordan, 24",
    quoteKey: "testimonial_quote_3",
    description: `“The virtual try-on feature lets me see exactly how outfits will
          look on me, which makes shopping so much easier. It’s like the app
          knows my body better than I do. My style game has seriously leveled
          up.”`,
  },
  {
    img: TES5,
    title: "Alex, 20",
    quoteKey: "testimonial_quote_4",
    description: `“Zilouet not only did it level up my look, but it also saved me so
          much time and effort. I don’t have to waste hours searching for the
          perfect outfit. The app just gets my vibe and makes shopping a
          breeze. My wardrobe’s never looked this good, and I barely had to
          lift a finger.”`,
  },
  {
    img: TES1,
    title: "Skylar, 19",
    quoteKey: "testimonial_quote_1",
    description: `“Zilouet surprised me with pieces I wouldn’t normally choose, but
          they totally work with my wardrobe and look great on me. It’s like
          having a style-savvy friend who knows exactly what I need.”`,
  },
  {
    img: TES2,
    title: "Jamie, 22",
    quoteKey: "testimonial_quote_2",
    description: `“Zilouet is seriously a lifesaver! When I order stuff online, I
          never have to return anything because it all fits perfectly. The app
          knows my body so well that even clothes from different stores are
          the right size. It’s like having a personal stylist who totally gets
          my style.”`,
  },
  {
    img: TES3,
    title: "Avery, 20",
    quoteKey: "testimonial_quote_3",
    description: `“The virtual try-on feature lets me see exactly how outfits will
          look on me, which makes shopping so much easier. It’s like the app
          knows my body better than I do. My style game has seriously leveled
          up.”`,
  },
  {
    img: TES4,
    title: "Jordan, 24",
    quoteKey: "testimonial_quote_3",
    description: `“The virtual try-on feature lets me see exactly how outfits will
          look on me, which makes shopping so much easier. It’s like the app
          knows my body better than I do. My style game has seriously leveled
          up.”`,
  },
  {
    img: TES5,
    title: "Alex, 20",
    quoteKey: "testimonial_quote_4",
    description: `“Zilouet not only did it level up my look, but it also saved me so
          much time and effort. I don’t have to waste hours searching for the
          perfect outfit. The app just gets my vibe and makes shopping a
          breeze. My wardrobe’s never looked this good, and I barely had to
          lift a finger.”`,
  },
];

const Testimonials = () => {
  const [slide, setSlide] = useState(1);
  const { scrollY } = useScroll();
  const overlayHeight = 2400;
  const ref = useRef(null);
  const isMobile = useIsMobile(744);
  const { t } = useI18n();

  useMotionValueEvent(
    scrollY,
    "change",
    (latest) => {
      if (!ref.current?.offsetParent) return;
      const value =
        (100 * (latest - ref.current.offsetParent.offsetTop)) / overlayHeight;

        if (value > 72) {
          setSlide(4);
        } else if (value > 54) {
          setSlide(3);
        } else if (value > 36) {
          setSlide(2);
        } else if (value > 18) {
          setSlide(1);
        } else {
          setSlide(0);
        }
    },
    []
  );

  return (
    <div style={{ position: "relative"}}>
      <div className={style.main}>
        <video autoPlay loop muted playsInline webkit-playsinline>
          <source
            src="/videos/testimonials_section_for_home_page.mp4"
            type="video/mp4"
          />
        </video>
        <div className={style.container}>
          <h2>
            {t("home_why_title")}
            <br />
            {t("home_why_zilouet")}
          </h2>

          <img src={PhoneImg} alt="" className="phone" />
        </div>
        <div className={style.slider}>
          <div
            className="wrapper"
            style={{
              left: (isMobile ? 90 : 0) + slide * (isMobile ? -250 : -290),
            }}
          >
            {Object.values(testimonials).map((item, i) => {
              return (
                <div className={`item tes${slide + 5 - i}`} key={i}>
                  <p>{t(item.quoteKey)}</p>
                  <div>
                    <img src={item.img} alt={item.title} />
                    <h5>{item.title}</h5>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className={style.progressBar}>
          <span style={{ width: (slide + 1) * 20 + "%" }}></span>
        </div>
      </div>
      <div
        tabIndex={1}
        ref={ref}
        className={style.overlay(overlayHeight)}
      ></div>
    </div>
  );
};

const style = {
  overlay: (overlayHeight) =>
    css({
      width: "100%",
      height: overlayHeight,
    }),
  progressBar: css({
    position: "absolute",
    backgroundColor: "#E0DDE4",
    width: 177,
    height: 12,
    borderRadius: 80,
    overflow: "hidden",
    bottom: 60,
    zIndex: 1,
    left: 0,
    right: 0,
    margin: "auto",

    span: {
      width: "100%",
      backgroundColor: "#7600FF",
      height: 12,
      transition: "all 2s",
      zIndex: 2,
      position: "relative",
      display: "block",
      borderRadius: 80,
    },

    [tablet]: {
      bottom: 100,
    },
  }),
  scroller: css({
    width: "100%",
    height: 400,
    top: 0,
    position: "absolute",
    left: 0,
    zIndex: 3,
    overflowY: "scroll",
    overflowX: "hidden",

    "&::-webkit-scrollbar": {
      display: "none",
    },
    span: {
      width: "100%",
      display: "block",
    },
  }),
  slider: css({
    maxWidth: 1450,
    position: "absolute",
    top: '50vh',
    margin: "auto",
    left: 0,
    right: 0,

    ".wrapper": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 15,
      position: "absolute",
      transition: "all 2s",
    },
    ".item": {
      position: "relative",
      borderRadius: 39,
      justifyContent: "space-between",
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      padding: 39,
      paddingLeft: 28,
      paddingRight: 28,
      background: "#F7E9DC",
      boxShadow: "0px 4px 4.7px 0px rgba(5, 6, 9, 0.12)",
      width: "220px !important",
      transition: "all 2s",
      opacity: "0",
      top: 110,

      "&.tes1, &.tes2, &.tes3, &.tes4, &.tes5": {
        opacity: "1",
      },

      "&.tes5": {
        transform: "rotate(-5.52deg)",
        top: 60,
      },
      "&.tes4": {
        transform: "rotate(-2.74deg)",
        top: 30,
      },
      "&.tes3": {
        top: 0,
      },
      "&.tes2": {
        transform: "rotate(2.43deg)",
        top: 30,
      },
      "&.tes1": {
        transform: "rotate(5.04deg)",
        top: 60,
      },
      "&.tes0": {
        transform: "rotate(7.50deg)",
        top: 90,
      },
      "&.tes6": {
        transform: "rotate(-7.50deg)",
        top: 90,
      },

      img: {
        width: 75,
        height: 75,
        top: 0,
      },

      h5: {
        color: "#000",
        fontFamily: "Syne",
        fontSize: 23.955,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal",
      },
      p: {
        color: "#000",
        fontFamily: "Inter",
        fontSize: 13,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.13,
      },

      div: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "space-between",
        width: "100%",
        marginTop: 50,
      },
    },
    [desktop]: {
      maxWidth: 870,

      ".item": {
        opacity: "0",

        "&.tes3, &.tes4, &.tes5, &.tes6": {
          opacity: "1",
        },

        "&.tes6": {
          transform: "rotate(-5.04deg)",
          top: 60,
        },
        "&.tes5": {
          transform: "rotate(-2.74deg)",
          top: 30,
        },
        "&.tes4": {
          transform: "rotate(0deg)",
          top: 0,
        },
        "&.tes3": {
          transform: "rotate(2.43deg)",
          top: 30,
        },
        "&.tes2": {
          transform: "rotate(5.04deg)",
          top: 60,
        },
        "&.tes1": {
          transform: "rotate(7.50deg)",
          top: 90,
        },
      },
    },
    [laptop]: {
      maxWidth: 900,
    },
    [tablet]: {
      maxWidth: 400,
      bottom: 450,
      ".wrapper": {
        gap: 30,
      },
      ".item": {
        width: "176px !important",
        padding: 30,
        paddingLeft: 20,
        paddingRight: 20,

        "&.tes3, &.tes4, &.tes5, &.tes6": {
          opacity: "1",
        },

        "&.tes6": {
          transform: "rotate(-2.74deg)",
          top: 30,
        },
        "&.tes5": {
          transform: "rotate(0)",
          top: 0,
        },
        "&.tes4": {
          transform: "rotate(2.43deg)",
          top: 30,
        },
        "&.tes3": {
          transform: "rotate(5.04deg)",
          top: 60,
        },
        "&.tes2": {
          transform: "rotate(7.50deg)",
          top: 90,
        },
        "&.tes1": {
          transform: "rotate(7.50deg)",
          top: 90,
        },
        h5: {
          fontSize: 16,
        },
        p: {
          fontSize: 11,
        },
        div: {
          justifyContent: 'flex-start',
          marginTop: 30,
        },
        img: {
          width: 55,
          height: 55,
          marginRight: 20,
        },
      },
    },
  }),
  main: css({
    position: "sticky",
    height: '100vh',
    overflow: "hidden",
    zIndex: 1,
    top: 0,

    video: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      left: 0,
      top: 0,
      zIndex: "0",
    },
    [desktop]: {},
    [laptop]: {},
    [tablet]: {
    },
  }),
  container: css({
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: 1172,
    margin: "auto",
    paddingLeft: 40,
    paddingRight: 40,
    marginBottom: 0,
    zIndex: 1,

    ".phone": {
      width: 600,
      height: "auto",
      position: "absolute",
      left: 0,
      right: 0,
      margin: "auto",
      top: '3vh',
    },

    [desktop]: {
      ".phone": {
        width: 580,
        top: '6vh',
      },
    },
    [laptop]: {},
    [tablet]: {
      paddingBottom: 120,
      ".phone": {
        width: 400,
        bottom: 0,
        top: '17vh',
      },
    },
    [mobile]: {
      ".phone": {
        width: 375,
        bottom: 0,
      },
    }
  }),
};

export default Testimonials;
